var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconsDk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.1 11.4",
    style: {
      enableBackground: "new 0 0 17.1 11.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#405C40;}\r\n\t.st1{clip-path:url(#SVGID_00000096781701859699521210000011598721250244494012_);fill:#405C40;}\r\n\t.st2{clip-path:url(#SVGID_00000011000744801613200690000008052070645239049890_);fill:#405C40;}\r\n\t.st3{clip-path:url(#SVGID_00000052097197193563005460000015045732465253222066_);fill:#405C40;}\r\n\t.st4{clip-path:url(#SVGID_00000091017400162297058130000010162636151803038884_);fill:#405C40;}\r\n\t.st5{clip-path:url(#SVGID_00000138536084673337210330000008632698825701192849_);fill:#405C40;}\r\n\t.st6{fill:#CD2D40;}\r\n\t.st7{fill:#0D468F;}\r\n\t.st8{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    width: 5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.7,
    className: "st6",
    width: 5,
    height: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.9,
    className: "st6",
    width: 10.2,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.9,
    y: 6.7,
    className: "st6",
    width: 10.2,
    height: 4.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "17.1,4.7 17.1,6.7 6.9,6.7 6.9,11.4 5,11.4 5,6.7 0,6.7 0,4.7 5,4.7 5,0 6.9,0 6.9,4.7  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconsDk);
export default __webpack_public_path__ + "static/media/InfoIcons_Dk.e099f68e3ab090bcbaf597db2f6b52d0.svg";
export { ForwardRef as ReactComponent };